import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

// Sparkline chart controller using ApexCharts
// Usage: data-controller="sparkline"
//        data-sparkline-data-value="[1,2,3,4,5]"
//        data-sparkline-categories-value='["Jan 1","Jan 2",...]'
//        data-sparkline-name-value="Users"
export default class extends Controller {
  static values = {
    data: Array,
    categories: Array,
    name: { type: String, default: "Value" },
    color: { type: String, default: "#2563eb" },
    height: { type: Number, default: 30 }
  }

  connect() {
    this.initChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  initChart() {
    const isDarkMode = document.documentElement.classList.contains("dark")

    const options = {
      series: [{
        name: this.nameValue,
        data: this.dataValue
      }],
      chart: {
        height: this.heightValue,
        type: "bar",
        sparkline: {
          enabled: true
        },
        animations: {
          enabled: false
        }
      },
      plotOptions: {
        bar: {
          columnWidth: "60%",
          borderRadius: 0
        }
      },
      colors: [this.colorValue],
      stroke: {
        curve: "straight",
        width: 2
      },
      xaxis: {
        type: "category",
        categories: this.categoriesValue,
        crosshairs: {
          show: false
        }
      },
      markers: {
        hover: {
          size: 0
        }
      },
      tooltip: {
        marker: {
          show: false
        },
        fixed: {
          enabled: true,
          position: "topLeft",
          offsetX: 0,
          offsetY: -10
        },
        custom: ({ series, seriesIndex, dataPointIndex, w }) => {
          const value = series[seriesIndex][dataPointIndex]
          const category = w.globals.categoryLabels[dataPointIndex] || this.categoriesValue[dataPointIndex] || ""

          return `<div class="px-2 py-1 text-xs bg-gray-900 dark:bg-neutral-700 text-white rounded shadow">
            <div class="font-medium">${category}</div>
            <div>${this.nameValue}: ${value}</div>
          </div>`
        }
      }
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }

  // Handle theme changes
  updateTheme() {
    if (this.chart) {
      this.chart.destroy()
      this.initChart()
    }
  }
}
